import Registration from "@registration";
import Tickets from "@tickets";
import OrderAssign from "@orderassign";
import Proposal from "@proposal";

// constant
import { ALLOWED_LAYOUTS } from "@constant";

// Common
import ThankYou from "@thankyou";
import SupportTicketThankYou from "@supportticketthankyou";
import ContactUnsubscribe from "@contactunsubscribe";
import TermsConditions from "@termsconditions";
import PrivacyPolicy from "@privacypolicy";
import RefundPolicy from "@refundpolicy";
import StripeCallback from "@stripecallback";
import PaypalCallback from "@paypalcallback";
import RazorpayCallback from "@razorpaycallback";
import ReviewerLogin from "@reviewerlogin";
import ReviewerDashboard from "@reviewerdashboard";
import Badge from "@badgedesign";

var routes = [
  {
    path: "/register",
    name: "Register",
    icon: "",
    component: <Registration />,
    display: false,
    key: "register",
    layout: ALLOWED_LAYOUTS.admin,
  },
  {
    path: "/register/:formid",
    name: "Register",
    icon: "",
    component: <Registration />,
    display: false,
    key: "register",
    layout: ALLOWED_LAYOUTS.admin,
  },
  {
    path: "/tickets",
    name: "Tickets",
    icon: "",
    component: <Tickets />,
    display: false,
    key: "tickets",
    layout: ALLOWED_LAYOUTS.admin,
  },
  {
    path: "/tickets/:ticketcode",
    name: "Tickets",
    icon: "",
    component: <Tickets />,
    display: false,
    key: "tickets",
    layout: ALLOWED_LAYOUTS.admin,
  },
  {
    path: "/tickets/:ticketcode/:source",
    name: "Tickets",
    icon: "",
    component: <Tickets />,
    display: false,
    key: "tickets",
    layout: ALLOWED_LAYOUTS.admin,
  },
  {
    path: "/tickets/ticketorder/:ordernumber",
    name: "TicketOrder",
    icon: "",
    component: <OrderAssign />,
    display: false,
    key: "tickets",
    layout: ALLOWED_LAYOUTS.admin,
  },
  {
    path: "/proposal/:proposalid",
    name: "Proposal",
    icon: "",
    component: <Proposal />,
    display: false,
    key: "proposal",
    layout: ALLOWED_LAYOUTS.admin,
  },
  {
    path: "/proposal/:proposalid/:responseid",
    name: "Proposal",
    icon: "",
    component: <Proposal />,
    display: false,
    key: "proposal",
    layout: ALLOWED_LAYOUTS.admin,
  },

  // common
  {
    path: "/thank-you",
    name: "Thank You",
    icon: "",
    component: <ThankYou />,
    display: false,
    key: "thankyou",
    layout: ALLOWED_LAYOUTS.admin,
  },
  {
    path: "/badge/:appuserid",
    name: "Badge",
    icon: "",
    component: <Badge />,
    display: false,
    key: "badge",
    layout: ALLOWED_LAYOUTS.admin,
  },
  {
    path: "/terms-conditions",
    name: "Terms Conditions",
    icon: "",
    component: <TermsConditions />,
    display: false,
    key: "terms-conditions",
    layout: ALLOWED_LAYOUTS.admin,
  },
  {
    path: "/privacy-policy",
    name: "Privacy Policy",
    icon: "",
    component: <PrivacyPolicy />,
    display: false,
    key: "privacy-policy",
    layout: ALLOWED_LAYOUTS.admin,
  },
  {
    path: "/refund-policy",
    name: "Refund Policy",
    icon: "",
    component: <RefundPolicy />,
    display: false,
    key: "refund-policy",
    layout: ALLOWED_LAYOUTS.admin,
  },
  {
    path: "/stripe_callback/:stipeaccountid",
    name: "StripeCallback",
    icon: "",
    component: <StripeCallback />,
    display: false,
    key: "stripecallback",
    layout: ALLOWED_LAYOUTS.admin,
  },
  {
    path: "/eventify_callback/:stipeaccountid", // Only changed the path, but calling the same StripeCallback component, Because as per url we are sending the gateway params in confirm payment payload
    name: "EventifyCallback",
    icon: "",
    component: <StripeCallback />,
    display: false,
    key: "eventifycallback",
    layout: ALLOWED_LAYOUTS.admin,
  },
  {
    path: "/paypal_callback/:transactionid",
    name: "PaypalCallback",
    icon: "",
    component: <PaypalCallback />,
    display: false,
    key: "paypalcallback",
    layout: ALLOWED_LAYOUTS.admin,
  },
  {
    path: "/razorpay_callback/:transactionid",
    name: "RazorpayCallback",
    icon: "",
    component: <RazorpayCallback />,
    display: false,
    key: "razorpaycallback",
    layout: ALLOWED_LAYOUTS.admin,
  },
  {
    path: "/supportticketthankyou",
    name: "Support Ticket Thank You",
    icon: "",
    component: <SupportTicketThankYou />,
    display: false,
    key: "supportticketthankyou",
    layout: ALLOWED_LAYOUTS.admin,
  },
  {
    path: "/reviewer/login",
    name: "",
    icon: "",
    component: <ReviewerLogin />,
    display: true,
    key: "reviewerlogin",
    layout: ALLOWED_LAYOUTS.reviewer,
  },
  {
    path: "/reviewer",
    name: "",
    icon: "",
    component: <ReviewerDashboard />,
    display: true,
    key: "reviewerdashboard",
    layout: ALLOWED_LAYOUTS.reviewer,
  },
  {
    path: "/contactunsubscribe",
    name: "Contact Unsubscribe",
    icon: "",
    component: <ContactUnsubscribe />,
    display: false,
    key: "contactunsubscribe",
    layout: ALLOWED_LAYOUTS.admin,
  },
];
export default routes;
